import { render, staticRenderFns } from "./ColoursTable.vue?vue&type=template&id=135debaf"
import script from "./ColoursTable.vue?vue&type=script&lang=js"
export * from "./ColoursTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports